import {createFeatureSelector} from "@ngrx/store";
import {AdminState} from "./index";

export const adminStateFeatureKey = 'adminState';

export const adminStateFeatureSelector = createFeatureSelector<AdminState>(
    adminStateFeatureKey
);